import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { Grid } from "@mui/material";

import { FormSelect } from "../../hooks-form-querybuilder/form-select.component";
import FormDateField from "../../hooks-form-querybuilder/form-date.field.component";
import { FormInputTime } from "../../../../components/hook-form/form-input.time.component";

export const ScheduleEmailForm = () => {
    const { setValue, getValues } = useFormContext();
    const intervalOptions = [
        {
            value: 'daily',
            label: 'Daily',
            isDefault: false,
        },
        {
            value: 'weekly',
            label: 'Weekly',
            isDefault: false,
        },
        {
            value: 'monthly',
            label: 'Monthly',
            isDefault: false,
        },
        {
            value: 'annually',
            label: 'Annually',
            isDefault: false,
        },
    ];

    const daysOptions = [
        {
            value: 'monday',
            label: 'Monday',
            isDefault: false,
        },
        {
            value: 'tuesday',
            label: 'Tuesday',
            isDefault: false,
        },
        {
            value: 'wednesday',
            label: 'Wednesday',
            isDefault: false,
        },
        {
            value: 'thursday',
            label: 'Thursday',
            isDefault: false,
        },
        {
            value: 'friday',
            label: 'Friday',
            isDefault: false,
        },
        {
            value: 'saturday',
            label: 'Saturday',
            isDefault: false,
        }, {
            value: 'sunday',
            label: 'Sunday',
            isDefault: false,
        },
    ];

    const [interval, setInterval] = useState<any>();

    useEffect(() => {
        if (getValues('scheduleInterval')) { setInterval(getValues('scheduleInterval')); }
    }, [getValues('scheduleInterval')])

    const handleIntervalChange = (value: string) => {
        setInterval(value);
        setValue('scheduleDay', null);
        setValue('scheduleDate', null);
    }

    return (
        <Grid container spacing={2}>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
                <FormSelect label="Interval" name="scheduleInterval" options={intervalOptions} onChange={handleIntervalChange} />
            </Grid>
            {interval == "weekly" && (
                <Grid item lg={12} sm={12} xl={12} xs={12}>
                    <FormSelect label="Day" name="scheduleDay" options={daysOptions} />
                </Grid>
            )}
            {(interval == "monthly" || interval == 'annually') && (
                <Grid item lg={12} sm={12} xl={12} xs={12}>
                    <FormDateField label="Date" name="scheduleDate" />
                </Grid>
            )}
            <Grid item lg={12} sm={12} xl={12} xs={12}>
                <FormInputTime name="scheduleTime" label="Time" />
            </Grid>
        </Grid>
    );
}